import ACTIONS from "./MasterActionTypes";

//GET
export const getMasterListRequest = (payload) => ({
  type: ACTIONS.GET_MASTER_LIST_REQUEST,
  payload,
});

export const getMasterListResponse = (payload) => ({
  type: ACTIONS.GET_MASTER_LIST_RESPONSE,
  payload,
});

//POST
export const postMasterRequest = (payload) => ({
  type: ACTIONS.POST_MASTER_REQUEST,
  payload,
});

export const postMasterResponse = (payload) => ({
  type: ACTIONS.POST_MASTER_RESPONSE,
  payload,
});

export const postMasterResponseClear = () => ({
  type: ACTIONS.POST_MASTER_RESPONSE_CLEAR,
});

//PUT
export const putMasterRequest = (payload) => ({
  type: ACTIONS.PUT_MASTER_REQUEST,
  payload,
});

export const putMasterResponse = (payload) => ({
  type: ACTIONS.PUT_MASTER_RESPONSE,
  payload,
});

//PUT STATUS
export const putStatusMasterRequest = (payload) => ({
  type: ACTIONS.PUT_STATUS_MASTER_REQUEST,
  payload,
});

export const putStatusMasterResponse = (payload) => ({
  type: ACTIONS.PUT_STATUS_MASTER_RESPONSE,
  payload,
});
